import { useDroppable } from '@dnd-kit/core';
import { useMemo } from 'react';
import { groupTileInput } from '@utils/component-framework';
import { usePageContext } from '../../../../context.js';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useTaskContext } from '../../context.js';
import { DraggableTile } from './atom.draggable.js';
import { Dropzone } from './atom.dropzone/_dropzone.js';
import { GroupTile } from './atom.tile.js';
import { jsx } from 'react/jsx-runtime';

function GroupDropzone(props) {
  const {
    setNodeRef,
    isOver
  } = useDroppable({
    id: props.dropzone.id,
    disabled: !props.draggable
  });
  const pageContext = usePageContext();
  const context = useTaskContext();
  const userPlacedTilesInDropzone = useOpgavekompleksetEntry({
    select: entry => Object.entries(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).map(([key, value]) => {
      const typedValue = groupTileInput.entry.asTypeSafe(value);
      if (typedValue) {
        return {
          tileId: key,
          ...typedValue
        };
      }
    }).filter(it => !!it && it.dropzoneId === props.dropzone.id).sort((a, b) => a.order - b.order).map(tileEntry => props.tiles.find(it => it.id === tileEntry?.tileId)).filter(it => !!it)
  });
  const tilesInDropzone = useMemo(() => props.facitType === "user-entry" ? [...props.tiles.filter(tile => tile.options.fixed && tile.validation.expectedDropzoneId === props.dropzone.id), ...(userPlacedTilesInDropzone ?? [])] : props.tiles.filter(it => it.validation.expectedDropzoneId === props.dropzone.id).toReversed(), [props.dropzone.id, props.facitType, props.tiles, userPlacedTilesInDropzone]);
  return /*#__PURE__*/jsx(Dropzone, {
    dropzoneRef: setNodeRef,
    content: props.dropzone,
    isDraggingOverDropzone: isOver,
    theme: pageContext === "print" ? "dimmed" : "white",
    state: context === "input" ? "interactive" : "static",
    children: tilesInDropzone?.map(tile => props.draggable && !tile.options.fixed ? /*#__PURE__*/jsx(DraggableTile, {
      tile: tile,
      context: "dropzone",
      taskEntryKey: props.taskEntryKey,
      isDraggingItem: props.draggedItemKey === tile.id,
      state: props.facitType === "should-have" ? "should-have" : undefined
    }, tile.id) : /*#__PURE__*/jsx("div", {
      children: /*#__PURE__*/jsx(GroupTile, {
        context: "dropzone",
        taskEntryKey: props.taskEntryKey,
        tile: tile,
        state: props.facitType === "should-have" ? "should-have" : undefined
      })
    }, tile.id))
  });
}

export { GroupDropzone };
//# sourceMappingURL=input.dropzone.js.map
